(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["reflectionare-product-like"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('reflectionare-product-like')) {
    customElements.define('reflectionare-product-like', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.button = this.querySelector('button');
        this.count = this.querySelector('.reflectionare-like-count');
        this.label = this.querySelector('.reflectionare-like-label');
        this.error = this.querySelector('.reflectionare-like-error');
        this.liked = false;
        this.ready = false;
        this.busy = false;
        this.abort = new AbortController();
        this.onRefresh = () => { if (!document.hidden && !this.busy) this.refresh(); };
        try {
          const key = 'reflectionare_like_visitor_v1';
          let visitor = localStorage.getItem(key);
          if (!/^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(visitor || '')) {
            visitor = crypto.randomUUID();
            localStorage.setItem(key, visitor);
          }
          this.endpoint = new URL(this.dataset.endpoint);
          this.endpoint.searchParams.set('product', this.dataset.product);
          this.endpoint.searchParams.set('visitor', visitor);
        } catch {
          this.count.textContent = '—';
          this.error.textContent = this.dataset.storage;
          return;
        }
        this.button.addEventListener('click', () => this.save(), { signal: this.abort.signal });
        document.addEventListener('visibilitychange', this.onRefresh, { signal: this.abort.signal });
        window.addEventListener('focus', this.onRefresh, { signal: this.abort.signal });
        window.addEventListener('reflectionare:likes-updated', this.onRefresh, { signal: this.abort.signal });
        this.timer = setInterval(this.onRefresh, 30000);
        this.refresh();
      }
      disconnectedCallback() {
        this.abort?.abort();
        clearInterval(this.timer);
        this.initialized = false;
      }
      async request(method, liked) {
        const options = { method, credentials: 'omit', cache: 'no-store', signal: AbortSignal.any([this.abort.signal, AbortSignal.timeout(12000)]) };
        if (method === 'PUT') {
          options.headers = { 'Content-Type': 'application/json' };
          options.body = JSON.stringify({ liked, handle: this.dataset.handle });
        }
        const response = await fetch(this.endpoint, options);
        if (!response.ok) throw new Error('Likes unavailable');
        const state = await response.json();
        if (!Number.isSafeInteger(state.count) || state.count < 0 || typeof state.liked !== 'boolean') throw new Error('Invalid count');
        return state;
      }
      show(state) {
        this.liked = state.liked;
        this.ready = true;
        this.count.textContent = String(state.count);
        this.label.textContent = state.liked ? this.dataset.liked : this.dataset.idle;
        this.button.setAttribute('aria-pressed', String(state.liked));
        this.error.textContent = '';
      }
      async refresh() {
        if (this.busy || !this.endpoint) return;
        this.busy = true;
        try {
          this.show(await this.request('GET'));
        } catch {
          if (!this.abort.signal.aborted) {
            this.ready = false;
            this.count.textContent = '—';
            this.error.textContent = this.dataset.error;
          }
        } finally {
          this.busy = false;
          this.button.disabled = false;
        }
      }
      async save() {
        if (this.busy) return;
        if (!this.ready) { await this.refresh(); return; }
        this.busy = true;
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        try {
          this.show(await this.request('PUT', !this.liked));
          window.dispatchEvent(new Event('reflectionare:likes-updated'));
        } catch {
          if (!this.abort.signal.aborted) {
            try { this.show(await this.request('GET')); } catch { this.ready = false; this.count.textContent = '—'; }
            this.error.textContent = this.dataset.error;
          }
        } finally {
          this.busy = false;
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
